<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <div class="groups-container">
    @if (groups.length > 0) {
<div class="groups-header">
      Retrigger Sync for below groups :
    </div>
}
    
    @if (groups.length > 0) {
<div class="groups-list">
      @for (tag of groups; track $index; let i = $index) {
<div class="group-tag">
        <div class="tag-icon">
          <i class="fa fa-tag"></i>
        </div>
        <div class="tag-name">{{tag}}</div>
        <div class="tag-remove" (click)="removeTag(i)">
          <i class="fa fa-times"></i>
        </div>
      </div>
}
    </div>
}
    
    @if (groups.length === 0) {
<div class="noIdBlock">
      No ID's selected.
    </div>
}
  </div>
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked || groups.length === 0"
          (click)="retriggerSyncGroup()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Retrigger Group Sync
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
